import gql from 'graphql-tag';

import DAILY_EXPANDED_FRAGMENT from './DAILY_EXPANDED_FRAGMENT';

const GET_SERVICE_RUN_DAILY_EXPANDED = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			...serviceRunDailyExpanded
		}
	}
	${DAILY_EXPANDED_FRAGMENT}
`;

export default GET_SERVICE_RUN_DAILY_EXPANDED;
